import { useEffect, useState } from "react";
import { Button, Toast, ToastContainer } from "react-bootstrap";
import companyApi from "../../../api/company";
import companyUserApi from "../../../api/companyUsers";
import AddCompanyModal from "../Comapnies/AddCompanyModal";
import AssignedComapnies from "../Comapnies/AssignedComapnies";
import CreatedCompanies from "../Comapnies/CreatedCompanies";
import TransferFrymes from "./transactionReport/company/TransferFrymes";

const CreditRequestCompany = () => {
  const [companyName, setCompanyName] = useState("");
  const [description, setDescription] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [country, setCountry] = useState("");
  const [location, setLocation] = useState("");

  const [showToast, setShowToast] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [userCompanies, setUserCompanies] = useState([]);
  const [assignedCompanies, setAssignedCompanies] = useState([]);

  const [activeTab, setActiveTab] = useState("myCompanies");

  useEffect(() => {
    const fetchUserCompanies = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user) return;

        const response = await companyApi.getListOfCompanyByAdminEmail(
          user.userEmail
        );
        setUserCompanies(Array.isArray(response.data) ? response.data : []);

        const assignedResponse =
          await companyUserApi.getAssignedCompaniesFromAdmin(user.userEmail);

        setAssignedCompanies(
          Array.isArray(assignedResponse.data) ? assignedResponse.data : []
        );
      } catch (error) {
        console.error("Error fetching user companies:", error);
      }
    };

    fetchUserCompanies();
  }, []);

  const handleSubmitRequest = async () => {
    try {
      setLoading(true);

      const user = JSON.parse(localStorage.getItem("user"));

      const companyData = {
        companyName,
        description,
        adminUserName: user?.userName,
        adminEmail: user?.userEmail,
        mobileNumber,
        country,
        location,
      };

      const response = await companyApi.createCompany(companyData);

      if (response && response.data) {
        setShowToast(true);

        // reset fields
        setCompanyName("");
        setDescription("");
        setMobileNumber("");
        setCountry("");
        setLocation("");

        setShowModal(false); // ✅ close modal
      }
    } catch (error) {
      console.error("Error submitting company credit request:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Buttons */}
      <div className="d-flex align-items-center gap-2 mt-3">
        <Button
          variant={activeTab === "myCompanies" ? "primary" : "outline-primary"}
          onClick={() => setActiveTab("myCompanies")}
        >
          My Companies
        </Button>

        <Button
          variant={
            activeTab === "assignedCompanies"
              ? "primary"
              : "outline-primary"
          }
          onClick={() => setActiveTab("assignedCompanies")}
        >
          Assigned Companies
        </Button>

        <Button variant="success" onClick={() => setShowModal(true)}>
          ➕ Add Company
        </Button>
         <Button variant="info" onClick={() => setShowTransferModal(true)}>
          Transfer Frymes
        </Button>
      </div>

      {/* Tabs */}
      <div className="mt-3">
        {activeTab === "myCompanies" ? (
          <CreatedCompanies />
        ) : (
          <AssignedComapnies />
        )}
      </div>

      {/* Modal */}
      <AddCompanyModal
        show={showModal}
        onClose={() => setShowModal(false)}
        companyName={companyName}
        setCompanyName={setCompanyName}
        mobileNumber={mobileNumber}
        setMobileNumber={setMobileNumber}
        description={description}
        setDescription={setDescription}
        country={country}
        setCountry={setCountry}
        location={location}
        setLocation={setLocation}
        handleSubmitRequest={handleSubmitRequest}
        loading={loading}
      />

      {/* Toast */}
      <ToastContainer position="top-end" className="p-3">
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={3000}
          autohide
          bg="success"
        >
          <Toast.Header>
            <strong className="me-auto">Company Added</strong>
          </Toast.Header>
          <Toast.Body className="text-white">
            Company Added successfully.
          </Toast.Body>
        </Toast>
      </ToastContainer>

      <TransferFrymes
        show={showTransferModal}
        onClose={() => setShowTransferModal(false)}
      />
    </>
  );
};

export default CreditRequestCompany;